import {Form, Formik} from 'formik';
import {useEffect, useState} from 'react';
import Button from '../../../../../../../../../frontend/src/components/form/button/button';
import SingleSelectDropdown from '../../../../../../../../../frontend/src/components/form/singleSelectDropdown/singleSelectDropdown';
import * as Yup from 'yup';
import './anonymous-scoring-event.scss';
import { useLocation } from 'react-router-dom';
import {useDispatch} from 'react-redux';
import { submitVoteRequest } from '../../../../../../../redux/anonymous-scoring/anonymousScoringSlice';

export default function AnonymousScoringEvent({
  label,
  data,
  handleAnonymousScoringAction,
}) {
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const sessionId = queryParams.get('sessionId'); // Retrieve sessionId from the URL
  const encodedEventName = queryParams.get('eventName'); // Retrieve eventName from the URL
  const eventName = encodedEventName ? encodedEventName.replace(/-/g, ' ') : '';
  const [likelihoodScore, setLikelihoodScore] = useState({});
  const [severityScore, setSeverityScore] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const likelihoodList = [
    {id: 1, name: 'Rare'},
    {id: 2, name: 'Unlikely'},
    {id: 3, name: 'Possible'},
    {id: 4, name: 'Likely'},
    {id: 5, name: 'Almost Certain'}
  ];
  const severityList = [
    {id: 1, name: 'Minor'},
    {id: 2, name: 'Medium'},
    {id: 3, name: 'Serious'},
    {id: 4, name: 'Major'},
    {id: 5, name: 'Catastrophic'}
  ];

  const initialValues = {
    likelihood: undefined,
    severity: undefined,
  };

  const validate = Yup.object({
    likelihood: Yup.string().required('Likelihood is Required'),
    severity: Yup.string().required('Severity is Required'),
  });

  const handleSubmit = () => {
    if (Object.keys(likelihoodScore).length > 0 && Object.keys(severityScore).length > 0) {
      dispatch(submitVoteRequest(
        { 
          'sessionId': sessionId,
          'likelihoodScore': likelihoodScore, 
          'severityScore': severityScore 
        }
      ));
      setIsSubmitted(true);
    } else {
      alert("Please provide values for both likelihood and severity scores.");
    }
  };

  return (
    <div className="anonymous-scoring-event-container">
      <div className="anonymous-scoring-event-form">
        <div className="header">
          <p className="label mt-3 mb-4">{label}</p>
        </div>
        <h3 className="title">KRAS Potential Unwanted Event Scoring</h3>
        <br/>
        <h4>Event:</h4>
        <h4>{eventName}</h4>
        <br/>
        <Formik
          initialValues={initialValues}
          validationSchema={validate}
          onSubmit={handleSubmit}>
          {({
            formik,
            values,
            setFieldValue,
            isSubmitting,
            isValid,
            errors,
            touched,
          }) => (
            <Form>
              <div className="user-multiselect">
                <SingleSelectDropdown
                  label="Likelihood"
                  listItems={likelihoodList}
                  name="likelihood"
                  value={values.likelihood}
                  handleSelectedUsersChange={val => {
                    setFieldValue('likelihood', val.id);
                    setLikelihoodScore(val);
                  }}
                  showError={true}
                  disabled={isSubmitted}
                />
              </div>
              <div className="user-multiselect">
                <SingleSelectDropdown
                  label="Severity"
                  listItems={severityList}
                  name="severity"
                  value={values.severity}
                  handleSelectedUsersChange={val => {
                    setFieldValue('severity', val.id);
                    setSeverityScore(val);
                  }}
                  showError={true}
                  disabled={isSubmitted}
                />
              </div>
              <div className="action-buttons">
                <Button type="submit" clickHandler={handleSubmit} variant="submit-button" disabled={isSubmitted}>
                  Submit Score
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}
